export const getModalStyles = (theme) => ({
    tarjeta: {
      backgroundColor: theme.palette.mode === 'dark' ? ' ' : '#e3f2fd',
      borderRadius: '25px',
      padding: '20px',
      marginBottom: '20px',
    },
});

export const getNotesSectionsStyles = (theme) => ({
  itemContainer: {
    margin: '5px 5px',
    padding: '10px',
    cursor: 'pointer',
    borderRadius: '15px',
    backgroundColor: theme.palette.mode === 'dark' ? '#404040' : "#e4e4e7",
    whiteSpace: 'normal',
    position: 'relative',
  },
  selectedContainer: {
    margin: '5px 5px',
    padding: '12px',
    cursor: 'pointer',
    borderRadius: '15px',
    backgroundColor: theme.palette.mode === 'dark' ? '#235789' : '#bdbdbd',
    whiteSpace: 'normal',
    position: 'relative',
  },
  itemName: {
    color: theme.palette.mode === "dark" ? '#ffffff' : '#000000',
    fontSize: '16px',
    fontWeight: 500,
    whiteSpace: 'normal',
    textTransform: 'capitalize',
  },
});
